import { toggleLoginModal } from 'platform/site-wide/user-nav/actions';
import React from 'react';
import { useDispatch } from 'react-redux';

const CheckAppStatusAlert = () => {
  const dispatch = useDispatch();
  return (
    <va-alert status="info" data-testid="hca-check-status-alert">
      <h2 slot="headline">Have you already applied for VA healthcare?</h2>
      <p>You can check the status of your application online.</p>
      <p>
        <va-button
          text="Sign in to check your application status"
          data-testid="hca-login-alert-button"
          onClick={() => dispatch(toggleLoginModal(true))}
        />
      </p>
      <p>
        <va-link
          text="Learn what to do after applying for healthcare benefits"
          href="/health-care/after-you-apply/"
        />
      </p>
    </va-alert>
  );
};

export default React.memo(CheckAppStatusAlert);
